import { TouchEvent, useState } from "react";

export enum SwipeDirection {
  Horizontal = "horizontal",
  Vertical = "vertical",
}

interface ISwipeInput {
  swipeDirection: SwipeDirection;
  onSwipeLeftOrUp: () => void;
  onSwipeRightOrDown: () => void;
}

interface ISwipeOutput {
  onTouchStart: (e: TouchEvent) => void;
  onTouchMove: (e: TouchEvent) => void;
  onTouchEnd: () => void;
}

interface ICoordinates {
  xPosition: number;
  yPosition: number;
}

const useSwipe = ({
  swipeDirection,
  onSwipeLeftOrUp,
  onSwipeRightOrDown,
}: ISwipeInput): ISwipeOutput => {
  const [touchStart, setTouchStart] = useState<ICoordinates | undefined>(
    undefined
  );
  const [touchEnd, setTouchEnd] = useState<ICoordinates | undefined>(undefined);

  const minSwipeDistance = 50;

  const onTouchStart = (e: TouchEvent) => {
    setTouchEnd(undefined);
    setTouchStart({
      xPosition: e.targetTouches[0].clientX,
      yPosition: e.targetTouches[0].clientY,
    });
  };

  const onTouchMove = (e: TouchEvent) => {
    setTouchEnd({
      xPosition: e.targetTouches[0].clientX,
      yPosition: e.targetTouches[0].clientY,
    });
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distanceX = touchStart.xPosition - touchEnd.xPosition;
    const distanceY = touchStart.yPosition - touchEnd.yPosition;

    const relevantDistance =
      swipeDirection === SwipeDirection.Horizontal ? distanceX : distanceY;
    const auxDistance =
      swipeDirection === SwipeDirection.Horizontal ? distanceY : distanceX;

    const leftOrUpSwipe = relevantDistance > minSwipeDistance;
    const rightOrDownSwipe = relevantDistance < -minSwipeDistance;

    const isValidMovement = Math.abs(relevantDistance) > Math.abs(auxDistance);

    if (isValidMovement)
      if (leftOrUpSwipe) {
        onSwipeLeftOrUp();
      } else if (rightOrDownSwipe) {
        onSwipeRightOrDown();
      }
  };

  return {
    onTouchStart,
    onTouchMove,
    onTouchEnd,
  };
};

export default useSwipe;
